enum MessageNamespace {
    SHARE_LINKS_CLIENT = 'AdoptShareLinksClientMessage',
    SHARE_LINKS_MESSENGER = 'AdoptShareLinksMessengerMessage',
}

export default MessageNamespace;
